import Footer from "./Footer";

// SynopticSection component accepts 'data' prop containing weather summary information
const SynopticSection = ({ data }) => {
  // If data is not present or empty, don't render the section
  if (!data?.data?.[0]) return null;

  // Destructure relevant fields from the first element in the data array
  const {
    synopticSituationHeadingText,
    synopticSituationSummaryText,
    synopticSituationBulletText,
    mapPhoto, // image path from API
    mapText,
  } = data.data[0]; // only the latest publish date data and text will be fetched

  // Convert HTML bullet points into an array of cleaned strings
  const bullets = synopticSituationBulletText
    .replace(/<\/?ul>/g, "") // remove <ul> tags
    .replace(/<\/?li>/g, "|") // replace <li> with a delimiter
    .split("|") // split into array
    .map((text) => text.trim()) // trim whitespace
    .filter((text) => text.length > 0); // remove empty strings

  return (
    <>
      {/* Section heading */}
      <div id="synoptic-section">
        <h4 className="synoptic-section-heading">
          <span className="section-number">2</span>
          <span className="section-title-text">Weather Outlook</span>
        </h4>
      </div>

      {/* Synoptic section main container */}
      <div className="synoptic-section">
        {/* Subsection title */}
        <h3 className="section-title">2a. Synoptic Situation</h3>

        {/* Summary paragraph */}
        <p className="synoptic-summary">{synopticSituationSummaryText}</p>

        {/* Heading for bullet points */}
        <h4 className="subheading">i. {synopticSituationHeadingText}</h4>

        {/* Render list of bullet points */}
        <ul className="impact-list">
          {bullets.map((point, idx) => (
            <li key={idx}>{point}</li>
          ))}
        </ul>

        {/* Map image caption */}
        <p className="image-caption">{mapText}</p>

        {/* Display image from API if available, else fallback */}
        <img
          src={mapPhoto ? mapPhoto : ""}
          alt="Rainfall Anomaly Outlook"
          className="synoptic-section-image"
        />

        {/* Image source note */}
        <p className="image-source">
          Source: PAKISTAN METEOROLOGICAL DEPARTMENT
        </p>

        {/* Footer component with page number */}
        <div style={{ marginTop: "150px" }}>
          <Footer
            footerNumber="4"
            footerText={"Weekly Water & Weather Report"}
          />
        </div>
      </div>
    </>
  );
};

export default SynopticSection;
